import uuidv4 from '@/utilities/uuid.js'
import * as R from 'ramda'
import api from '@/api'
import { successPipeline } from '@/api/pipelines/success-pipeline.js'

const commodityItemPresenter = (commodityItem, itemId) => {
  return {
    id: itemId,
    description: commodityItem.description,
    price: commodityItem.price,
    defaultProduction: commodityItem.defaultProduction
  }
}

const state = {
  commodityItems: {}
}

const mutations = {
  LOAD_COMMODITY_ITEMS (state, payload) {
    state.commodityItems = payload
  },

  ADD_COMMODITY_ITEM (state, { id, item }) {
    const items = {
      ...state.commodityItems,
      [id]: item
    }
    state.commodityItems = items
  },

  UPDATE_COMMODITY_ITEM (state, { id, item }) {
    state.commodityItems[id] = item
  },

  DELETE_COMMODITY_ITEM (state, payload) {
    state.commodityItems = R.omit(payload, state.commodityItems)
  }
}

const actions = {
  updateCommodityItem ({ commit, getters }, jsConn) {
    if (jsConn.formParams.id === 'new') {
      const id = uuidv4()
      jsConn.formParams = {
        id: id,
        item: jsConn.formParams.item
      }

      if (getters.signedIn) {
        return api.createCommodity(jsConn)
          .then(jsConn => {
            return successPipeline(jsConn)
          })
          .then(jsConn => {
            jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully saved'
            commit('ADD_COMMODITY_ITEM', jsConn.formParams)
            return Promise.resolve(jsConn)
          })
          .catch(jsConn => {
            jsConn.toastMessage = 'Unable to save ' + jsConn.formParams['item']['description']
            return Promise.reject(jsConn)
          })
      } else {
        jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully saved for this browser session'
        commit('ADD_COMMODITY_ITEM', jsConn.formParams)
        return Promise.resolve(jsConn)
      }
    } else {
      if (getters.signedIn) {
        return api.updateCommodity(jsConn)
          .then(jsConn => {
            return successPipeline(jsConn)
          })
          .then(jsConn => {
            commit('UPDATE_COMMODITY_ITEM', jsConn.formParams)
            jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully updated'
            return Promise.resolve(jsConn)
          })
          .catch(jsConn => {
            jsConn.toastMessage = 'Unable to save ' + jsConn.apiParams['item']['description']
            return Promise.reject(jsConn)
          })
      } else {
        commit('UPDATE_COMMODITY_ITEM', jsConn.formParams)
        jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully updated for this browser session'
        return Promise.resolve(jsConn)
      }
    }
  },

  deleteCommodityItem ({ commit, getters, dispatch }, jsConn) {
    if (getters.signedIn) {
      return api.deleteCommodity(jsConn)
        .then((jsConn) => {
          return successPipeline(jsConn)
        })
        .then(jsConn => {
          dispatch('deleteCommodityItemFromAllCrops', jsConn)
          commit('DELETE_COMMODITY_ITEM', [jsConn.formParams['id']])
          jsConn.toastMessage = 'Commodity item deleted'
          return Promise.resolve(jsConn)
        })
        .catch(jsConn => {
          jsConn.toastMessage = 'Unable to delete item'
          return Promise.reject(jsConn)
        })
    } else {
      dispatch('deleteCommodityItemFromAllCrops', jsConn)
      commit('DELETE_COMMODITY_ITEM', [jsConn.formParams['id']])
      jsConn.toastMessage = 'Commodity item deleted for this browser session'
      return Promise.resolve(jsConn)
    }
  }
}

const getters = {
  commodityItems: state => state.commodityItems,

  commodityItemsIdList: state => {
    return Object.keys(state.commodityItems)
  },

  commodityItemsList: (state, getters) => {
    const itemsList = R.map((itemId) => {
      const item = getters.getCommodityItemById(itemId)
      return commodityItemPresenter(item, itemId)
    }, getters.commodityItemsIdList)

    return itemsList
  },

  getCommodityItemById: (state) => (id) => {
    return state.commodityItems[id]
  },

  getCommoditiesForAutocomplete: (state, getters) => {
    return getters.commodityItemsIdList.map((item) => {
      const commodity = getters.getCommodityItemById(item)
      return {
        value: item,
        text: commodity.description
      }
    })
  }
}

const commodityModule = {
  state,
  mutations,
  actions,
  getters
}

export default commodityModule
